import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { getAssemblybySo } from "../../api";
import { Header, Button } from "../../components";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import LoadingIndicator from "../LoadingIndicator";

const ViewAssembly = () => {
  const navigate = useNavigate();
  let param = useParams();
  const so_id = param.so_id;
  const gridRef = useRef(null);
  const [Sns, setSns] = useState([]);
  const [formData, setFormData] = useState({
    part: "Select Part",
    sku: "",
    lot_no: "",
    order_qty: 0,
    assemble_qty: 0,
    ship_qty: 0,
  });
  const [loadBtn, setLoadBtn] = useState(false);

  const snsGrid = [
    {
      field: "gpu_sn",
      headerText: "GPU SN",
      minWidth: "80",
      width: "140",
      textAlign: "left",
    },
    {
      field: "wb_sn",
      headerText: "Block SN",
      minWidth: "80",
      width: "170",
      textAlign: "left",
    },
    {
      field: "test_result",
      headerText: "Test Res",
      minWidth: "40",
      width: "100",
      textAlign: "left",
    },
    {
      field: "test_scan_date",
      headerText: "Test Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "40",
      width: "125",
      textAlign: "center",
    },
    {
      field: "install_date",
      headerText: "Assm Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "40",
      width: "125",
      textAlign: "center",
    },
    {
      field: "ship_date",
      headerText: "Ship Date",
      type: "datetime",
      format: "dd/MM/yyyy HH:mm",
      minWidth: "40",
      width: "125",
      textAlign: "center",
    },
    {
      field: "lot_no",
      headerText: "Lot #",
      minWidth: "80",
      width: "100",
      textAlign: "left",
    },
    {
      field: "box_id",
      headerText: "Box ID",
      minWidth: "180",
      width: "170",
      textAlign: "left",
    },
  ];

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/GpuWb");
  };

  useEffect(() => {
    async function fetchData() {
      if (so_id) {
        setLoadBtn(true);
        TimeoutUtility.resetTimeout();
        await getAssemblybySo(so_id)
          .then(async (resp) => {
            const assys = resp.data;
            if (assys.length > 0) {
              setSns(assys || []);
              const rec = assys[0];
              setFormData((prev) => ({
                ...prev,
                sku: rec.sku,
                part: rec.part_number + " - " + rec.part_description,
                lot_no: rec.lot_no,
                box_id: rec.box_id,
                box_qrcode: rec.box_qrcode,
                order_qty: rec.total_quantity,
                assemble_qty: assys.length,
                ship_qty: resp.data.filter((item) => item.ship_date === null)
                  .length,
              }));
            }
            setLoadBtn(false);
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [so_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="WORK ORDER ASSEMBLIES" />
      {loadBtn ? (
        <LoadingIndicator />
      ) : (
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col xl={6} lg={6} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="SO:"
                  name="so_id"
                  value={so_id}
                  placeholder="Name"
                  disabled
                />
                <TextInputField
                  label="Order Part:"
                  name="part"
                  value={formData.part}
                  placeholder="Part"
                  disabled
                />
                <TextInputField
                  label="SKU:"
                  name="sku"
                  value={formData.sku}
                  placeholder="SKU"
                  disabled
                />
              </div>
            </Col>
            <Col xl={6} lg={6} className="container-col">
              <div className="col-lg-12">
                <DoubleField
                  label="Order Quantity:"
                  name="order_qty"
                  value={formData.order_qty}
                  placeholder="Order Quantity"
                  disabled
                />
                <DoubleField
                  label="Assemble Quantity:"
                  name="assemble_qty"
                  value={formData.assemble_qty}
                  placeholder="Assemble Quantity"
                  disabled
                />
                <DoubleField
                  label="Ship Quantity:"
                  name="ship_qty"
                  value={formData.ship_qty}
                  placeholder="Ship Quantity"
                  disabled
                />
              </div>
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <GridComponent
              ref={gridRef}
              className="custom-grid1 pt-8"
              dataSource={Sns}
              height="calc(50vh - 180px)"
              allowResizing
              rowHeight={32}
            >
              <ColumnsDirective>
                {snsGrid.map((item, index) => (
                  <ColumnDirective key={index} {...item} />
                ))}
              </ColumnsDirective>
              <Inject services={[Resize]} />
            </GridComponent>
          </Row>
        </Container>
      )}
      <Row md={"auto"} className="justify-content-center pt-8">
        <Button
          margin="10px"
          padding="20px"
          text="Close"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ViewAssembly;
